<div class="view-wrapper">
  <div class="panels">

    <!-- SOL PANEL -->
    <div class="left-side-panel" [ngClass]="{ 'overlapping': isXSmall, 'open': isRightPanelOpen }">
      <div class="side-panel-container">
        <div class="side-panel-content-wrapper">
          <div class="side-panel-content">

            <!-- Butonlar -->
            <div class="buttons">
              <dx-button text="Tabloya Dön" stylingMode="contained" type="danger" class="ml-16" (onClick)="goBack()"></dx-button>
              <dx-button text="Bugün" type="default" stylingMode="contained" (onClick)="onSelectedDateChange()"></dx-button>
              <dx-button text="Ekle" type="success" stylingMode="contained" (onClick)="showAppointmentCreationForm()"></dx-button>
            </div>

            <!-- Takvim -->
            <dx-calendar [value]="currentDate" (valueChange)="onCalendarDateChange($event)"></dx-calendar>

            <!-- DKM-5509 Cedric: nikah memuru süzgeci (salon süzgeci aşağıdaki salon listesi) -->
            <div class="suzgec-alan">
              <div class="suzgec-baslik">Nikah memuru</div>
              <dx-select-box
                [items]="memurSuzgecSecenekleri"
                displayExpr="aciklama"
                valueExpr="kod"
                [value]="memurSuzgec"
                placeholder="Tüm memurlar"
                [showClearButton]="true"
                [searchEnabled]="true"
                (onValueChanged)="memurSuzgecDegisti($event.value)">
              </dx-select-box>
              <div class="suzgec-baslik">Salonlar</div>
            </div>

            <div class="buttons">
              <dx-button
                [text]="selectAllButtonText"
                stylingMode="contained"
                type="default"
                size="small"
                (onClick)="toggleAllSelection()">
              </dx-button>
            </div>

            <!-- Takvim Listesi -->
            <dx-list
              class="calendar-list"
              [dataSource]="listDataSource"
              [activeStateEnabled]="false"
              [focusStateEnabled]="false"
              [hoverStateEnabled]="false"
              [scrollingEnabled]="false">
              <div *dxTemplate="let item of 'item'">
                <div class="list-item">
                  <dx-check-box
                    [value]="selectedItems.includes(item)"
                    (onValueChanged)="selectionChanged(item, $event.value)">
                  </dx-check-box>
                  <span class="list-item-text">{{ item.text }}</span>
                </div>
              </div>
            </dx-list>

          </div>
        </div>
      </div>
    </div>

    <!-- SCHEDULER -->
    <div class="scheduler-container">
      <dx-scheduler
        #schedulerRef
        height="inherit"
        [adaptivityEnabled]="isXSmall"
        [allDayPanelMode]="'hidden'"
        [dataSource]="tasks"
        [currentView]="currentView"
        [currentDate]="currentDate"
        [startDayHour]="9"
        [showCurrentTimeIndicator]="false"
        (currentViewChange)="onCurrentViewChange($event)"
        (onAppointmentClick)="onAppointmentClick($event)"
        (onAppointmentTooltipShowing)="onAppointmentTooltipShowing($event)"
        (onAppointmentAdded)="appointmentAdded($event)"
        (onAppointmentUpdated)="appointmentUpdated($event)"
        (onAppointmentDeleted)="appointmentDeleted($event)"
        (currentDateChange)="onSchedulerDateChange($event)"
        appointmentTemplate="agendaAppointmentTemplate"
        (onAppointmentFormOpening)="onAppointmentFormOpening($event)"
        >

        <!-- Templates -->
        <div *dxTemplate="let data of 'calendarIdTemplate'">
          <dk-ct-gen-lookup
            [selectedValue]="selectedAppointment?.data.calendarId"
            (valueChange)="beyanData.calendarId = $event?.value"
            [lookUpType]="'ETS_SALON'"
            [valueExpr]="'kod'">
          </dk-ct-gen-lookup>
        </div>

        <div *dxTemplate="let data of 'kisiKodTemplate'">
          <dk-ctl-gen-kisi
            #control
            [labelText]="'Kişi Kod'"
            [code]="selectedAppointment?.data.kisiKod"
            (dataResult)="itemChange3($event)">
          </dk-ctl-gen-kisi>
        </div>

        <div *dxTemplate="let data of 'nikahMemurKodTemplate'">
          <dk-ct-gen-lookup
            [selectedValue]="selectedAppointment?.data.nikahMemurKod"
            (valueChange)="beyanData.nikahMemurKod = $event?.value"
            [lookUpType]="'ETS_MEMUR_AD'"
            [dataSourceFilter]="memurFiltre"
            [valueExpr]="'kod'">
          </dk-ct-gen-lookup>
        </div>

        <div *dxTemplate="let data of 'evlenBeyanKodTemplate'">
          <dk-ctl-gen-kontrol
            #control
            [labelText]="'Evlen Beyan'"
            [controlName]="'EtsBeyan'"
            [code]="selectedAppointment?.data.evlenBeyanKod"
            (dataResult)="itemChange($event)">
          </dk-ctl-gen-kontrol>
        </div>

        <!-- Views -->
        <dxi-view type="day"></dxi-view>
        <dxi-view type="workWeek"></dxi-view>
        <dxi-view type="week" [firstDayOfWeek]="1"></dxi-view>
        <dxi-view type="month"></dxi-view>
        <dxi-view type="agenda" [appointmentTemplate]="'agendaAppointmentTemplateAgent'"></dxi-view>

        <!-- Agenda Appointment Template -->
<div *dxTemplate="let data of 'agendaAppointmentTemplate'">
  <div class="tooltip-target-{{data.appointmentData.id}}">
    <ng-container *ngFor="let field of [
      { label: 'Açıklama', value: data.appointmentData.text },
      { label: 'Başlangıç', value: (data.appointmentData.startDate | date:'short') },
      { label: 'Bitiş', value: (data.appointmentData.endDate | date:'short') },
      { label: 'Kişi', value: data.appointmentData.kisiKod },
      { label: 'Salon', value: data.appointmentData.salonLabel }
    ]">
      <div><b>{{ field.label }}:</b> {{ field.value }}</div>
    </ng-container>

    <dx-tooltip
      target=".tooltip-target-{{data.appointmentData.id}}"
      showEvent="mouseenter"
      hideEvent="mouseleave"
      [position]="{ my: 'top', at: 'bottom', collision: 'flipfit' }"
      [width]="200"
      [container]="'.dx-viewport'">
      <div class="tooltip-content">
        {{ data.appointmentData.agentLabel }}
      </div>
    </dx-tooltip>
  </div>
</div>


            <div *dxTemplate="let data of 'agendaAppointmentTemplateAgent'">
  <div class="custom-tooltip">
    <b>{{ data.appointmentData.agentLabel}}</b>
  </div>
</div>
      </dx-scheduler>

    </div>

  </div>
</div>
